<script setup lang="ts">
import { ref } from 'vue';
import useDocumentLang from '@/hooks/useDocumentLang';
import CardRecommendation from '@/components/standardComponents/pageComponent/CardRecommendation/CardRecommendation.vue';
import Search from '@/components/common/Search/Search.vue';
import HotWords from '@/components/common/HotWords/HotWords.vue';
import Tabs from '@/components/common/Tabs/Tabs.vue';
import { useRouter } from 'vue-router';
import { isProd } from '@/utils/env';

const router = useRouter();

// 初始化文档语言
useDocumentLang();

// Tab 配置 - 根据环境区分
const prodTabs = [
    { label: 'Animal', value: '17' },
    { label: 'Art', value: '19' },
    { label: 'Cars', value: '32' },
    { label: 'Tech', value: '11' },
    { label: 'Travel', value: '10' },
    { label: 'Desserts', value: '39' },
];
const devTabs = [
    { label: 'Universe', value: '16' },
    { label: 'Game', value: '5' },
    { label: 'Travel', value: '10' },
];
const tabs = isProd ? prodTabs : devTabs;

// 热词配置
const hotWords = [
    'cats',
    'coffee',
    'health',
    'plants',
    'wedding',
    'nature',
    'cake',
    'recipe',
];

// 当前选中的分类 ID, 默认为第一个 tab
const selectedCategory = ref(tabs[0].value);

// 点击搜索按钮, 以 URL 参数的形式携带搜索词, 跳转到搜索结果页
const handleSearch = (query: string) => {
    console.log('[HomePage]-handleSearch', { query });
    router.push({
        name: 'Result',
        query: { q: encodeURIComponent(query) },
    });
};
</script>

<template>
    <!-- 搜索组件 - Home 模式 -->
    <Search allowDuplicate mode="home" @search="handleSearch" />

    <!-- 热词组件 -->
    <HotWords :words="hotWords" @select="handleSearch" />

    <!-- Tab 切换组件 -->
    <Tabs v-model="selectedCategory" :tabs="tabs" />

    <!-- 相关推荐大卡组件 -->
    <CardRecommendation
        :categoryId="selectedCategory"
        :contentConfig="{ defaultExpand: false, abstractRow: 6 }"
    />
</template>
